<template>
    <div>
        <title>券卡出库</title>
        <article class="cardArticle">
            <section class="cardCon">
                <header class="tabHeader">
                    <p>
                        <router-link  :to="{path:'/CardsOut'}"  class="isActive" v-if="openStoreDefinition==1">券卡定义激活</router-link>
                        <router-link  :to="{path:'/CardsActivation'}">券卡激活</router-link>
                        <router-link :to="{path:'/CardsPause'}">券卡暂停</router-link>
                         <router-link  :to="{path:'/CardsReuse'}">券卡恢复</router-link>
                         <router-link :to="{path:'/CardsRecover'}" v-if="ElementControls('erjimendian')==1">销售回收</router-link>
                         <router-link :to="{path:'/CardMdShop'}" v-if="ElementControls('erjimendian')==1">门店铺券</router-link>
                    </p>
                </header>
                <CardOut :type="2" :batchcode="batchcode"></CardOut>
            </section>
        </article>
    </div>
</template>
<script>
import Api from "@/apis/api.js";
import { mapState, mapActions } from "vuex";
export default {
  name: "CardsOut",
  // ==================================== 组件====================================
  components: {
    CardOut: resolve => require(["@/components/CardsFolder/CardOut.vue"],resolve), // 出库组件
  },
  data() {
    return {
      openStoreDefinition:0,
      cardqupd:0,
      batchcode:'',
    };
  },
   // ==================================== 计算属性 ====================================
    computed: {
      ...mapState({
        bdis: ({ common }) => common.bdis,
      })
    },
  // ============================================== 方法 ==============================================
  methods: {
   
  },
  mounted() {
    this.openStoreDefinition = this.ElementControls('openStoreDefinition')
		this.cardqupd =this.ElementControls('cardqupd')
    if(this.$route.query.batchcode){
      this.batchcode =  this.$route.query.batchcode;
    }
  },
};
</script>
<style scoped>
/* S 验证券卡 */
.cardCon {
  position: relative;
  padding: 84px 20px 85px 0;
  height: calc(100% - 169px);
}
@media (max-width: 1310px) {
  .cardCon header a {
    padding: 0 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CardsFolder/CardsGift/CardManage/CardsRecordOut.vue